import { render, staticRenderFns } from "./laurent-perrier.vue?vue&type=template&id=0bb5a96f&scoped=true"
import script from "./laurent-perrier.vue?vue&type=script&lang=js"
export * from "./laurent-perrier.vue?vue&type=script&lang=js"
import style0 from "./laurent-perrier.vue?vue&type=style&index=0&id=0bb5a96f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb5a96f",
  null
  
)

export default component.exports